import React, { useEffect } from 'react';
import { Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { foodScoreStore } from '../../stores/foodScoreStore';
import { PageTitle } from '../../../shared/components/ui-components';
import { TAB_VALUES, TabValue } from '../../constants/TAB_VALUES';
import { LbTabPanel, LbTabs, LbUnderlineTabsList } from '../../../shared/components/tabs';
import { FinalTable } from './containers/FinalTable/FinalTable';
import { WorkingTable } from './containers/WorkingTable/WorkingTable';

const { WORKING_TABLE_TAB, FINAL_TABLE_TAB } = TAB_VALUES;

const NgzFoodScore = observer(() => {
  const {
    getFinalTableData,
    getFoodScoreTypes,
    activeTab,
    setActiveTab,
    finalTableTotal,
    workingTableTotal,
  } = foodScoreStore;

  useEffect(() => {
    getFinalTableData();
    getFoodScoreTypes();
  }, []);

  const handleTabChange = (newValue: TabValue) => {
    setActiveTab(newValue);
  };

  const tabsConfigs = [
    {
      label: `Working Table (${workingTableTotal})`,
      value: WORKING_TABLE_TAB,
      panel: <WorkingTable />,
    },
    {
      label: `Final Table (${finalTableTotal})`,
      value: FINAL_TABLE_TAB,
      panel: <FinalTable />,
    },
  ];

  return (
    <Container>
      <LbTabs value={activeTab} onValueChange={handleTabChange}>
        <PageTitle
          title="Workspace"
          tabs={<LbUnderlineTabsList tabsConfig={tabsConfigs} />}
        />
        <LbTabPanel tabsConfig={tabsConfigs} />
      </LbTabs>
    </Container>
  );
});

angularizeWithProviders(NgzFoodScore, 'ngzFoodScore', {});

export { NgzFoodScore };
